export interface LetterRequestCustomer_Cancel {
  id:number,
  code:String,
  code2:String,
  persianDate:string,
  clock:string,
  customerName:string,
  activity_date:string,
  activity_user:string,
  customerId:number,
  letter_id:number,
  coordination:number,
  done:number,
  DeletingProccess:boolean,
  dscVisible:boolean,
  activityVisible: boolean,
  relative_id:Array<number>
}

export function Empty_LetterRequestCustomer_Cancel():LetterRequestCustomer_Cancel{
  return{
    id:0,
    code:'',
    code2:'',
    persianDate:'',
    clock:'',
    customerName:'',
    activity_date:'',
    activity_user:'',
    customerId:0,
    letter_id:0,
    coordination:0,
    done:0,
    DeletingProccess:false,
    dscVisible:false,
    activityVisible: false,
    relative_id:[]
  }
}
